import { useCallback, useEffect, useState } from 'react';
import { apiService } from '../../services/api';

// Appels des programmes (routes /programmes et /projects/{id}/programme).

export const programmesApi = {
  me: () => apiService.get('/programmes/me'),
  access: () => apiService.get('/programmes/access'),
  setAccess: (employeeId, allowed) => apiService.put(`/programmes/access/${employeeId}`, { allowed }),
  list: () => apiService.get('/programmes'),
  create: (body) => apiService.post('/programmes', body),
  get: (id) => apiService.get(`/programmes/${id}`),
  update: (id, body) => apiService.put(`/programmes/${id}`, body),
  remove: (id) => apiService.delete(`/programmes/${id}`),
  addProject: (id, projectId) => apiService.post(`/programmes/${id}/projects`, { project_id: projectId }),
  removeProject: (id, projectId) => apiService.delete(`/programmes/${id}/projects/${projectId}`),
  refreshSummaries: (id) => apiService.post(`/programmes/${id}/summaries`, {}),
  // C/K global : concepts du programme ; un projet se range sous le concept qu'il explore.
  concepts: (id, operations) => apiService.post(`/programmes/${id}/ck`, { operations }),
  attach: (id, projectId, conceptId) => apiService.post(`/programmes/${id}/ck/attach`, { project_id: projectId, concept_id: conceptId }),
  runSuggestions: () => apiService.post('/programmes/suggestions/run', {}),
  acceptSuggestion: (id, body) => apiService.post(`/programmes/suggestions/${id}/accept`, body || {}),
  rejectSuggestion: (id) => apiService.post(`/programmes/suggestions/${id}/reject`, {}),
  ofProject: (projectId) => apiService.get(`/projects/${projectId}/programme`),
  reconstruct: (projectId, now = false) => apiService.post(`/projects/${projectId}/programme/reconstruct`, { now }),
  cancelReconstruct: (projectId) => apiService.delete(`/projects/${projectId}/programme/reconstruct`),
  known: (projectId, nodeId) => apiService.get(`/projects/${projectId}/programme/known/${nodeId}`),
  carryOptions: (projectId) => apiService.get(`/projects/${projectId}/programme/carry`),
  carry: (projectId, body) => apiService.post(`/projects/${projectId}/programme/carry`, body),
};

// Accès aux programmes (une requête par session) : Rémy d'abord, distinct du module Exploration.
let mePromise = null;
export const useProgrammeAccess = () => {
  const [me, setMe] = useState({ access: false, admin: false });
  useEffect(() => {
    let alive = true;
    mePromise = mePromise || programmesApi.me().catch(() => ({ access: false, admin: false }));
    mePromise.then((value) => { if (alive) setMe(value || { access: false }); });
    return () => { alive = false; };
  }, []);
  return me;
};

/** Le programme d'un projet (pour l'en-tête et l'onglet) : {access, programme, suggestions, similar, reconstruction}. */
export function useProjectProgramme(projectId) {
  const [state, setState] = useState(null);
  const reload = useCallback(async () => {
    try {
      const next = await programmesApi.ofProject(projectId);
      setState(next);
      return next;
    } catch {
      setState({ access: false });
      return null;
    }
  }, [projectId]);
  useEffect(() => { reload(); }, [reload]);
  return { data: state, reload };
}

// Couleur d'un projet dans les vues du programme (dans l'ordre de la frise).
export const PROJECT_COLORS = ['#6366f1', '#0ea5e9', '#10b981', '#f59e0b', '#ec4899', '#8b5cf6', '#14b8a6', '#f97316'];
export const projectColor = (index) => PROJECT_COLORS[index % PROJECT_COLORS.length];

/** Lien vers un élément d'exploration dans son projet. */
export const elementUrl = (projectId, nodeId, type) => (type === 'artefact'
  ? `/project/${projectId}?tab=artefacts&element=${nodeId}`
  : `/project/${projectId}?tab=arbre&element=${nodeId}`);
